import React, { useState } from "react";
import MonthLetterDatePicker from "./MonthLetterDatePicker";
import {
  emailValidation,
  negativeNumberValidation,
  validatePhone,
} from "../Utils/validation";
import Tooltip from "@mui/material/Tooltip";

const toDate = (dateStr) => {
  if (dateStr) return new Date(dateStr);
};

function Input(props) {
  const { img, label, name, handleChange, validation, items, view, sub } = props;

  const [error, setError] = useState(false);

  const onChangeEnd = (event) => {
    let errorDublicate = false;
    const value = event.target.value;

    if (validation === "phone") {
      if (value.trim().length !== 0 && !validatePhone(value)) {
        errorDublicate = true;
      }
    } else if (validation === "email" && !emailValidation(value)) {
      errorDublicate = true;
    } else if (validation === "marriage" && negativeNumberValidation(value)) {
      errorDublicate = true;
    } else if (["spouseName", "areaOfInterest", "occupation", "spouseOccupation"].includes(validation)) {
      errorDublicate = !/^[a-zA-Z\s]+$/.test(value);
    }

    setError(errorDublicate);
    handleChange(event, name);
  };

  const currentDate = new Date();

  const truncateLabel = (labelText, maxLength = 12) => {
    if (labelText.length > maxLength) {
      return `${labelText.substring(0, maxLength)}...`;
    }
    return labelText;
  };

  return (
    <div className="d-flex justify-content-between">
      <span className="det-label" style={{ width: validation === "lastPeriod" && "50%" }}>
        {img ? (
          <img
            src={(() => {
              try {
                return require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`);
              } catch (e) {
                try {
                  return require(`../../../../assets/DigitalMarketing/image/customer/${img}.svg`);
                } catch (e) {
                  return 'i'; // Replace with a default image if needed
                }
              }
            })()}
            alt="customer"
          />
        ) : null}
        
        <Tooltip title={label} arrow>
          <span className="cursor-pointer">
            {truncateLabel(label)}
          </span>
        </Tooltip>

        {sub && <sub>{sub}</sub>}
      </span>

      {validation === "lmp" || validation === "lastPeriod" || validation === "ovulationDate" ? (
        <div  className="dev_lmp">
          <img
            src={require(`../../../../assets/DigitalMarketing/image/customer/apoinment/date.png`)}
            style={{ marginBottom: "8px" }}
            className="img-picker"
            alt="i"
          />
          <div>
          <MonthLetterDatePicker
            selectedDate={toDate(props[name])}
            data={validation}
            currentDate={currentDate}
            onChange={onChangeEnd}
            view={view}
            name={name}
          />
          </div>
        </div>
      ) : validation === "date" ? (
        <input
          type="date"
          value={props[name] || ""}
          onChange={onChangeEnd}
          disabled={view}
          className={`text-custom ${error && "errorAlert"}`}
          name={name}
          style={{ textAlign: "left" }}
        />
      ) : (
        <input
          type={
            validation === "marriage" || validation === "phone" ? "text" : "text"
          }
          {...(validation === "marriage"
            ? {
                onInput: (e) => {
                  e.target["value"] = Math.abs(e.target["value"]);
                  let value = parseInt(e.target["value"]);
                  if (value > 100) value = 100;
                  else if (isNaN(value)) value = 0;
                  e.target["value"] = value;
                },
              }
            : {})}
          onKeyDown={
            ["phone1", "phone2", "avgPeriodLength", "cycleLength"].includes(name)
              ? (e) => {
                  const charCode = e.which ? e.which : e.keyCode;
                  if ((charCode < 48 || charCode > 57) && charCode !== 8) {
                    e.preventDefault();
                  }
                }
              : undefined
          }
          placeholder="Empty"
          value={props[name] || ""}
          style={{ textAlign: "left" }}
          disabled={view}
          className={`${
            validation === "phone" ? "text-custom number" : "text-custom"
          } ${error && "errorAlert"}`}
          name={name}
          onChange={onChangeEnd}
        />
      )}
    </div>
  );
}

export default React.memo(Input);
